
/*
* 派送司机页面路径枚举
* */
export enum DeliveringPath {
    DELIVERY_DELIVERING="/delivery/delivering",
    DELIVERY_DELIVERING_ORDER="/delivery/delivering/:trackingNumber",
    DELIVERY_MARK_EXCEPTION="/delivery/mark-exception",
    DELIVERY_SCAN_PACKAGE="/delivery/scan-package",
    DELIVERY_MAP_MODE="/delivery/map-mode",
    DELIVERY_CHAT="/delivery/chat",
    DELIVERY_CHAT_LIST="/delivery/chat-list",
    DELIVERY_ADDRESS_COORDINATE_FEEDBACK="/delivery/address-coordinate-feedback/:trackingNumber",
    DELIVERY_ADDRESS_COORDINATE_FEEDBACK_NATIVE="/delivery/address-coordinate-feedback/native/:trackingNumber"
}
/*
* 订单详情/派送页面路径枚举
* */
export enum DeliveryDetailPath {
    DELIVERY_DELIVERING_ORDER_DETAIL="/delivery/delivering/detail/:trackingNumber",
    DELIVERY_DELIVERING_ORDER_DETAIL_ADD_ACCESS_CODE="/delivery/delivering/detail/:trackingNumber/add-access-code",
    DELIVERY_DELIVERING_ORDER_DETAIL_ACCESS_INFO="/delivery/delivering/detail/:trackingNumber/access-info",
    DELIVERY_DELIVERING_ORDER_DETAIL_UPDATE_ACCESS_CODE="/delivery/delivering/detail/:trackingNumber/update-access-code",
}
/*
* 任务列表页面路径枚举
* */
export enum TaskPath {
    DELIVERY_TASK = "/delivery/task",
    DELIVERY_TASK_ASSIGNMENTS="/delivery/task/new-assignments",
    DELIVERY_TASK_ASSIGNMENTS_DETAILS="/delivery/task/new-assignments/details",
    DELIVERY_TASK_TRANSFER_IN="/delivery/task/transfer-in",
    DELIVERY_TASK_TRANSFER_IN_DETAILS="/delivery/task/transfer-in/details",
    DELIVERY_TASK_RETURN="/delivery/task/return",
    DELIVERY_TASK_TRANSFER_OUT="/delivery/task/transfer-out",
    DELIVERY_TASK_AREA_SCAN_DETAIL="/delivery/task/area-scan-detail",
}
/*
* DSP经理列表页面路径枚举
* */
export enum DspPath {
    DELIVERY_DSP_HOME = "/dsp/home",
    DELIVERY_DSP_TASK = "/dsp/task",
    DELIVERY_DSP_OPERATIONAL = "/dsp/operational",
    DELIVERY_DSP_OPERATIONAL_PARTICULARS = "/dsp/operational/particulars/:driverId",
    DELIVERY_DSP_OPERATIONAL_PARTICULARS_DETAIL = "/dsp/operational-data/particulars-detail/:trackingNumber",
    DELIVERY_DSP_OPERATIONAL_PARTICULARS_POD = "/dsp/operational-data/particulars-pod/:trackingNumber",
    DELIVERY_DSP_OPERATIONAL_PARTICULARS_MARK_FAIL = "/dsp/operational-data/particulars-mark-fail/:trackingNumber",
    DELIVERY_DSP_RECEIVING_SORTING_SCAN = "/dsp/home/receiving-sorting/scan",
    DELIVERY_DSP_RECEIVING_SORTING_DETAILS = "/dsp/home/receiving-sorting/details",
    DELIVERY_DSP_RECEIVING_SORTING_NEW_DETAILS = "/dsp/home/receiving-sorting/newDetails",
    DELIVERY_DSP_RECEIVING_SORTING_CONFIRM = "/dsp/home/receiving-sorting/confirm",
    DELIVERY_DSP_RECEIVING_SORTING_SUMMARY = "/dsp/home/receiving-sorting/summary",
    DELIVERY_DSP_PACKAGE_SCAN = "/dsp/home/scan",
    DELIVERY_DSP_TRACK_DETAIL = "/dsp/home/track-detail/:trackingNumber",
    DELIVERY_DSP_DELIVERED_POD = "/dsp/home/delivered-pod/:trackingNumber",
    DELIVERY_DSP_MARK_EXCEPTION = "/dsp/home/mark-exception/:trackingNumber",
    DELIVERY_DSP_DRIVER_VIOLATION_REVIEW = "/dsp/scan/driver-violation-review",
    DELIVERY_DSP_DELIVERY_TASK_DETAILS = "/dsp/delivery-task-details",
    DELIVERY_DSP_DELIVERY_TASK_MAP = "/dsp/delivery-task-map",
    DELIVERY_DSP_ISSUE_PARCEL_WORKBENCH = "/dsp/home/issue-parcel-workbench",
    DELIVERY_DSP_COMPLAINT_LIST = "/dsp/home/issue-parcel-workbench/complaint",
    DELIVERY_DSP_COMPLAINT_DETAIL = "/dsp/home/issue-parcel-workbench/complaint/:complaintId",
    DELIVERY_DSP_COMPLAINT_HISTORY = "/dsp/home/issue-parcel-workbench/complaint/history",
}

/*
* 少件提示
* */
export enum IncompletePromptPath {
    DELIVERY_NEW_ASSIGNMENT_START_CONFIRM = "/delivery/task/new-assignments-confirm",
    DELIVERY_TRANSFER_IN_START_CONFIRM = "/delivery/task/transfer-in-confirm",
}

/*
* 用户菜单列表页面路径枚举
* */
export enum UserMenuPath {
    USER_MENU_FAILED = "/delivery/failed",
    USER_MENU_DELIVERED = "/delivery/delivered",
    USER_MENU_IDENTIFICATION = "/delivery/identification",
    USER_MENU_SETTINGS = "/delivery/settings",
    USER_MENU_SETTINGS_LANGUAGE = "/delivery/settings/language",
    USER_MENU_SETTINGS_NAVIGATION_APP = "/delivery/settings/navigation-app",
    USER_MENU_SETTINGS_ROUTE_ENDPOINTS_NATIVE = "/delivery/settings/route-endpoints/native",
    USER_MENU_SETTINGS_ROUTE_ENDPOINTS_MAP_PICKER_NATIVE = "/delivery/settings/route-endpoints/map-picker/native",
}

/*
* native 入口(NativeApp.tsx)页面路径枚举
*
* 与上面各枚举分开：上面是 main 入口(App.tsx)的路由表，两个入口的路由表互斥，跨入口用 navigate() 会白屏。
* 注意别和 DriverAuthPath 里的 *_NATIVE 混淆——那些是 main 入口嵌 WebView 的老页面(如 /driver/register/native)，
* 本枚举才是 native 入口的新页面。
*
* 这些路径由原生 App 端硬编码直接打开(Android WebNativePathConstants.kt / iOS TTConfigConstants.swift)，
* 改路径必须同步 App 端，不能只改 Web。
* NativeApp.tsx 的路由表与所有跳转都必须引用本枚举，避免改一处漏一处。
* */
export enum DeliveryNativePath {
    DRIVER_REGISTER = "/delivery-native/driver/register",
    DRIVER_TERMS_OF_USE = "/delivery-native/driver/terms-of-use",
    DRIVER_PRIVACY_POLICY = "/delivery-native/driver/privacy-policy",
    DRIVER_CHANGE_PASSWORD = "/delivery-native/driver/change-password",
    DRIVER_BLACKLIST_SMS_VERIFICATION = "/delivery-native/driver/blacklist-sms-verification",
    DRIVER_WAGE_ARREARS_REPORT = "/delivery-native/driver/wage-arrears-report",
    SETTINGS_ROUTE_ENDPOINTS = "/delivery-native/settings/route-endpoints",
    SETTINGS_ROUTE_ENDPOINTS_MAP_PICKER = "/delivery-native/settings/route-endpoints/map-picker",
    ADDRESS_COORDINATE_FEEDBACK = "/delivery-native/address-coordinate-feedback/:trackingNumber",
    LEARNING_CENTER = "/delivery-native/driver/learning-center",
    LEARNING_CENTER_HOW_TO_DELIVER = "/delivery-native/driver/learning-center/how-to-deliver",
    LEARNING_CENTER_POD_GUIDE = "/delivery-native/driver/learning-center/pod-guide",
    LEARNING_CENTER_FAQ = "/delivery-native/driver/learning-center/faq",
    LEARNING_CENTER_PARCEL_PENDING_GUIDE = "/delivery-native/driver/learning-center/parcel-pending-guide",
    SETTLEMENT_BILL_SUMMARY = "/delivery-native/driver/settlement/bill-summary",
    SETTLEMENT_BILL_DETAIL = "/delivery-native/driver/settlement/bill-detail/:deliveredDate/:discountFlag",
    DRIVER_ACTIVITY = "/delivery-native/driver/activity",
    DRIVER_ACTIVITY_LIST = "/delivery-native/driver/activity/list",
    DRIVER_ACTIVITY_RULES = "/delivery-native/driver/activity/rules",
    DRIVER_ACTIVITY_WEEK = "/delivery-native/driver/activity/week",
    DRIVER_ACTIVITY_TODAY = "/delivery-native/driver/activity/today",
    DRIVER_ACTIVITY_REWARDS = "/delivery-native/driver/activity/rewards",
    DRIVER_ACTIVITY_REWARD_DETAIL = "/delivery-native/driver/activity/rewards/detail",
}

/*
* native 入口路径前缀。
* main / native 共用的组件靠这个前缀判断当前入口，决定跳转目标。
* */
export const DELIVERY_NATIVE_PATH_PREFIX = "/delivery-native/";
